import { render, staticRenderFns } from "./priceGuidance.vue?vue&type=template&id=737fcb9e&scoped=true"
import script from "./priceGuidance.vue?vue&type=script&lang=js"
export * from "./priceGuidance.vue?vue&type=script&lang=js"
import style0 from "./priceGuidance.vue?vue&type=style&index=0&id=737fcb9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737fcb9e",
  null
  
)

export default component.exports